import { http, HttpResponse, delay } from 'msw';

import {
  mockedOnboardings,
  simpleMockedOnboardings,
  simpleOnboarding,
  simpleOnboardingsWithStats,
} from '@/mocks/data/onboardingData';
import { requests } from '@/mocks/data/requestData';

export const onboardingHandlers = [
  http.get(
    `*/v1/organizations/:organizationId/onboardings`,
    async ({ request }) => {
      const activeOnly =
        new URL(request.url).searchParams.get('active_only') === 'true';
      const results = activeOnly
        ? simpleOnboardingsWithStats.filter(
            ({ onboarding }) => !onboarding.completed_at
          )
        : simpleOnboardingsWithStats;
      await delay();
      return HttpResponse.json(results, { status: 200 });
    }
  ),
  // Must be registered BEFORE `/onboardings/:onboardingId` so 'bulk' isn't
  // matched as an id.
  http.post(
    `*/v1/organizations/:organizationId/onboardings/bulk`,
    async ({ params }) => {
      await delay();
      return HttpResponse.json(
        {
          workflow_id: 'mock-bulk-onboarding-workflow-id',
          organization_id: params.organizationId,
        },
        { status: 200 }
      );
    }
  ),
  // Must be registered BEFORE `/onboardings/:onboardingId` so 'employees'
  // isn't matched as an id. The slice's transformResponse calls
  // `response.results.map(...)`, so we must return a paginated shape (not the
  // single-object shape the :onboardingId handler returns).
  http.get(
    `*/v1/organizations/:organizationId/onboardings/employees`,
    async () => {
      await delay();
      return HttpResponse.json({ results: [], total: 0 }, { status: 200 });
    }
  ),
  http.get(
    `*/v1/organizations/:organizationId/onboardings/:onboardingId`,
    async () => {
      if (simpleMockedOnboardings.length > 0) {
        await delay();
        return HttpResponse.json(
          {
            results: simpleMockedOnboardings[0],
          },
          { status: 200 }
        );
      } else {
        return new HttpResponse(null, { status: 404 });
      }
    }
  ),
  http.get(
    `*/v1/organizations/:organizationId/employees/:employeeId/onboarding`,
    async () => {
      await delay();
      // Same reason as the matching offboarding handler — return 200 + empty
      // body when no onboarding exists. A 404 here gets refetched
      // continuously by `useGetXboardingStatus` (`preferCacheValue: false`).
      if (mockedOnboardings.length > 0) {
        return HttpResponse.json(mockedOnboardings[0], { status: 200 });
      }
      return new HttpResponse(null, { status: 200 });
    }
  ),
  http.get(
    `*/v1/organizations/:organizationId/onboardings/:onboardingId/requests`,
    async () => {
      if (requests.length > 0) {
        await delay();
        return HttpResponse.json(
          {
            results: requests,
          },
          { status: 200 }
        );
      } else {
        return new HttpResponse(null, { status: 404 });
      }
    }
  ),
  http.post(`*/v1/organizations/:organizationId/onboardings`, async () => {
    // add the onboarding to the mock data (mutate the data)
    mockedOnboardings.push(simpleOnboarding);

    await delay();
    return new HttpResponse(null, { status: 200 });
  }),
];
